import { render, staticRenderFns } from "./exceptionCase.vue?vue&type=template&id=f88fb666&scoped=true"
import script from "./exceptionCase.vue?vue&type=script&lang=js"
export * from "./exceptionCase.vue?vue&type=script&lang=js"
import style0 from "./exceptionCase.vue?vue&type=style&index=0&id=f88fb666&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88fb666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f88fb666')) {
      api.createRecord('f88fb666', component.options)
    } else {
      api.reload('f88fb666', component.options)
    }
    module.hot.accept("./exceptionCase.vue?vue&type=template&id=f88fb666&scoped=true", function () {
      api.rerender('f88fb666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/exceptionCase.vue"
export default component.exports